const APIS = {
  DEFAULT_BRANCH: "/logisticservice/api/branch/default-branch/",
  USER: "/usermanagementservice/api/user/",
  STATUS: "/logisticservice/api/status/",
  FORM: "/formbuilderservice/api/dynamic-form/",
  FORM_FIELD: "/formbuilderservice/api/dynamic-form-field/",
  FORM_DATA: "/formbuilderservice/api/dynamic-form-data/",
};

export default APIS;
